import { render, staticRenderFns } from "./AddLeadResultItem.vue?vue&type=template&id=9a133ed2&"
import script from "./AddLeadResultItem.vue?vue&type=script&lang=js&"
export * from "./AddLeadResultItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports